export class CustomisableItem {
  id: string;
  price: number;
  priceChanges: any;
  default: boolean;
  defaultQuantity: number;
  providerData: any;

  constructor(id: string, price: number, isDefault: boolean, priceChanges: any) {
    this.id = id;
    this.price = price;
    this.priceChanges = priceChanges;
    this.default = isDefault;
    this.defaultQuantity = 0;
    this.providerData = {};
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
